import { Badge } from "../Badge";
import { Button } from "../Button";
import { Icon } from "../Icons";
import { Body, Heading } from "../Typography";
import "./SuggestionBlock.css";

export interface SuggestionBlockProps {
  /** Label displayed in the badge tag */
  tagLabel?: string;
  /** Title text displayed next to the badge */
  title: string;
  /** Description text displayed below the header */
  description: string;
  /** Callback when the Ignore button is clicked */
  onIgnore?: () => void;
  /** Callback when the Accept button is clicked */
  onAccept?: () => void;
}

export const SuggestionBlock = ({
  tagLabel = "SUGGESTED",
  title,
  description,
  onIgnore,
  onAccept,
}: SuggestionBlockProps) => {
  const hasActions = onIgnore || onAccept;

  return (
    <div className="indigo-suggestion-block">
      <div className="indigo-suggestion-block__header">
        <Badge label={tagLabel} variant="sky" size="sm" />
        <Heading level={4}>{title}</Heading>
      </div>
      <Body className="indigo-suggestion-block__description">
        {description}
      </Body>
      {hasActions && (
        <div className="indigo-suggestion-block__actions">
          {onIgnore && (
            <Button variant="ghost" size="sm" onClick={onIgnore}>
              Ignore
            </Button>
          )}
          {onAccept && (
            <Button variant="sky" size="sm" onClick={onAccept}>
              <Icon name="check" size="xs" />
              Accept
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
